var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"callout-comp",attrs:{"data-type":_vm.type}},[(_vm.emoji)?_c('div',{staticClass:"emoji mr8"},[_vm._v(_vm._s(_vm.emoji))]):_vm._e(),_c('div',{staticClass:"message"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }